import { render, staticRenderFns } from "./nav_phone.vue?vue&type=template&id=001cf706&scoped=true"
import script from "./nav_phone.vue?vue&type=script&lang=js"
export * from "./nav_phone.vue?vue&type=script&lang=js"
import style0 from "./nav_phone.vue?vue&type=style&index=0&id=001cf706&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001cf706",
  null
  
)

export default component.exports